module.exports = __webpack_public_path__ + "static/media/button-expand-window-active.9e2d517c.svg";